import React from 'react';
import rdLogo from '../images/r-d-logo.png';
import randdimg from "../images/randd-image.jpeg"
const ResearchAndDevelopment = () => {
  return (
    <div className="page service-page">
      <section className="service-hero-banner">
        <img src={rdLogo} alt="R and D Activities" className="service-hero-banner__image" />
        <div className="service-hero-banner__overlay">
          <h1>R&amp;D Activities</h1>
        </div>
      </section>

      <div className="container">
        <div className="page-hero">
          {/* <p className="hero-kicker">R&D Activities</p> */}
          
        </div>

       

          
    <section className="rd-showcase-section">
          <div className="rd-showcase-grid">
            <div className="rd-showcase-media">
              {/* <span className="rd-badge" aria-hidden="true">🧠</span> */}
              <img
                src={randdimg}
                alt="Tomato plant research plot"
                loading="lazy"
              />
            </div>

            <div className="rd-showcase-content">
              <p>
                There is a dedicated qualified R & D team working
                 on major vegetable crops viz., Tomato, Hot Peppers, 
                 Okra, Melons and Gourds. Ever changing demand for vegetable
                  hybrids to suit different market segments and agro-climatic
                   zones have led to strengthen Research and Development wing.
                    Its activities are focus for target markets of both domestic
                     and International. The company has already released several 
                     commercially viable hybrids.
              </p>

              <p>
                Tomato being a major crop of subtropics, 
                the company offers a wide range of high yielding hybrids. 
                These include processing, fresh market, dual purpose, in
                 determinates (outdoor and greenhouse culture). An array of
                  hybrids resistant to bacterial wilt, TYLCV, TMV, nematodes 
                  and a host of other temperate foliar and root diseases are in 
                  the process of development.
              </p>

            </div>
          </div>
        </section>

        <section className="rd-station-banner">
          <span className="rd-quote rd-quote-left" aria-hidden="true">&ldquo;</span>
          <p>
            The Research stations are located in two agro climatic conditions; Devanahalli near to Bangalore and
            South Karnataka, India.
          </p>
          <span className="rd-quote rd-quote-right" aria-hidden="true">&rdquo;</span>
        </section>

        <section className="rd-crop-notes">
          <p>
            Hot Pepper, a major crop of India is witnessing a shift from open pollinated varieties to hybrids.
            The company has kept pace with ever increasing demand of hybrids by releasing virus resistant
            materials and CMS hybrids to meet both green and red peppers.
          </p>
          <p>
            High yielding Okra hybrids with tolerance / resistance to YVMV &amp; Enation virus, Superior pod
            quality and yield. A series of hybrids have made a mark in the domestic and offshore markets.
          </p>
          <p>
            Watermelon and melons are major crops and the efforts have led to release of many commercially
            viable hybrids as per the market requirements like size, shape, sweetness, keeping quality and
            diseases tolerance.
          </p>
          <p>
            Gourds; The company is also focusing on the improvement of the traditional Asian vegetables like
            ridge gourd, bottle gourd, sponge gourd, and bitter gourd by releasing high quality and high
            yielding hybrids.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ResearchAndDevelopment;